// extracted by mini-css-extract-plugin
export var root = "video-popover-module--root--v3GE-";
export var video = "video-popover-module--video--Vtd1C";